export default "__VITE_ASSET__cLYTqTDK__"